import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { EventDetailsModel } from '../../../../providers/event/event';

/**
 * Generated class for the InfosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-infos',
  templateUrl: 'infos.html',
})
export class InfosPage {

  @Input("eventModel")
  event: EventDetailsModel;

  binData: { name: string, value: boolean }[] = [{ name: 'sflach', value: false }, { name: 'skflach', value: false }, { name: 'shuegel', value: false }, { name: 'sbergig', value: false }, { name: 'uasphalt', value: false }, { name: 'uwald', value: false }, { name: 'ugemischt', value: false }, { name: 'ucross', value: false }, { name: 'aumed', value: false }, { name: 'auurk', value: false }, { name: 'aushirt', value: false }, { name: 'augesch', value: false }, { name: 'podpokal', value: false }, { name: 'podmed', value: false }, { name: 'podsach', value: false }, { name: 'podgeld', value: false }, { name: 'essstreck', value: false }, { name: 'essziel', value: false }, { name: 'esswarm', value: false }, { name: 'esskuch', value: false }, { name: 'dusch', value: false }, { name: 'umkleid', value: false }, { name: 'wc', value: false }, { name: 'messe', value: false }];

  constructor(public navCtrl: NavController, public navParams: NavParams) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InfosPage');
  }

  bin2String() {
    var result = '';

    let array = [];
    for (let i = 0; i < Math.floor(this.binData.length / 8); i++) {
      var buffer = "";
      for (let z = 0; z < 8; z++) {
        buffer += this.binData[i * 8 + z].value ? "1" : "0";
      }
      array.push(buffer);
    }
    for (var i = 0; i < array.length; i++) {
      result += String.fromCharCode(parseInt(array[i], 2));
    }

    this.event.booleanData = result;
  }

  timeChange(a, b) {
    console.log(a);
    this.event[b] = ((a.hour * 3600) + (a.minute * 60)) * 1000;
    console.log(this.event);
  }
}



// WEBPACK FOOTER //
// /src/pages/event/create/infos/infos.ts